/** Snackbar-Meldungen für erfolgreiche Aktionen im Admin-Announcement-Feature. */
export const SNACKBAR_MESSAGES = {
  saveSuccess: 'Erfolgreich gespeichert.',
  publishSuccess: 'Erfolgreich veröffentlicht.',
  unpublishSuccess: 'Erfolgreich zurückgerufen.',
  deleteSuccess: 'Erfolgreich gelöscht.',
} as const;
